import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { ArrowUpward } from '@mui/icons-material';
import { Box, TableSortLabel, Typography } from '@mui/material';

const columnsData = [
    {
        id: 'id',
        name: 'ID',

        hideCellValue: true,

        renderElement: (row, currentCellValue) => {
            return (
                <span>
                    {row.firstName}
                    <button>hello {currentCellValue}</button>
                </span>
            );
        },
    },
    { id: 'firstName', name: 'First name' },
    { id: 'lastName', name: 'Last name' },
    {
        id: 'age',
        name: 'Age',
        type: 'number',
        showSortIcon: true,
    },
];
const rowsData = [
    { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
    { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },
    { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },
    { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
    { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: 20 },
];
function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

export default function CustomiseTable({
    columns = [...columnsData],
    rows = [...rowsData],
    componentStyleProps = {
        tableHeaderCellSx: {},
        tableBodyCellSx: {},
        tableSx: {},
        tableContainerSx: {},
    },
    hideHeader = false,
    showHeading = false,
    headingText = '',
}) {
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('');

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const visibleRows = React.useMemo(() => [...rows].sort(getComparator(order, orderBy)), [order, orderBy, rows]);
    return (
        <TableContainer
            component={Paper}
            sx={{
                ...componentStyleProps.tableContainerSx,
            }}
        >
            {showHeading && (
                <Box
                    padding={'1rem'}
                    sx={(theme) => ({
                        // borderBottom: `1px solid ${theme.palette.border.neutralPrimary}`,
                    })}
                >
                    <Typography component={'h2'} fontSize={'customFontSize.large'} fontWeight={'fontWeightSemiBold'}>
                        {headingText}
                    </Typography>
                </Box>
            )}
            <Table
                sx={(theme) => ({
                    minWidth: 650,
                    ...componentStyleProps.tableSx,
                    ...(showHeading
                        ? {
                              borderTop: `1px solid ${theme.palette.border.neutralPrimary}`,
                          }
                        : {}),
                })}
                aria-label="simple table"
            >
                {!hideHeader && (
                    <TableHead>
                        <TableRow>
                            {columns.map((currentColumn, index) => (
                                <TableCell
                                    key={index}
                                    align="left"
                                    sx={{
                                        '& .MuiButtonBase-root.MuiTableSortLabel-root': {
                                            visibility: 'hidden',
                                        },
                                        '&:hover .MuiButtonBase-root.MuiTableSortLabel-root': {
                                            visibility: 'visible',
                                        },

                                        ...componentStyleProps.tableHeaderCellSx,
                                    }}
                                    {...currentColumn.headCellProps}
                                >
                                    {currentColumn.name}

                                    <TableSortLabel
                                        IconComponent={ArrowUpward}
                                        active={orderBy === currentColumn.id ? true : false}
                                        hideSortIcon={!currentColumn.showSortIcon}
                                        direction={order}
                                        onClick={(e) => {
                                            handleRequestSort(e, currentColumn.id);
                                        }}
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                )}
                <TableBody>
                    {visibleRows?.length > 0 ? (
                        visibleRows.map((row, index) => {
                            return (
                                <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    {columns.map((cColumn) => {
                                        return (
                                            <TableCell
                                                key={cColumn.id}
                                                sx={{
                                                    ...componentStyleProps.tableBodyCellSx,
                                                    ...cColumn?.tableBodyCellSx,
                                                }}
                                            >
                                                {!cColumn.hideCellValue && typeof row[cColumn.id] === 'string' && row[cColumn.id]}{' '}
                                                {cColumn.renderElement && cColumn.renderElement(row, row[cColumn.id])}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })
                    ) : (
                        <TableRow>
                            <TableCell
                                align="center"
                                colSpan={columns?.length}
                                sx={(theme) => ({
                                    background: theme.palette.background.paper,
                                    color: theme.palette.text.secondary,
                                    borderColor: theme.palette.gray[200],
                                    fontSize: theme.typography.customFontSize.small, // 14px
                                    fontWeight: theme.typography.fontWeightRegular,
                                    lineHeight: '150%',
                                })}
                            >
                                No Data
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
